import { observable, action, toJS } from 'mobx';
import base from '../../tool/base';
import { message } from 'antd';
import util from '../../util/index';
const {
  getAccessToken,
  catchApiError,
} = util;
export class EcodeStore {

  constructor(routing) {
    this.routing = routing;
  }

  @observable loading = false;
  @observable fieldList = [];
  @observable propertyList = [];
  @observable demoInfo = {};
  @observable access_token = '';
  @observable id = '';
  @observable secondaryModule = '';
  @observable formParams = {}; // 表单值
  @observable disabledSubmit = false;
  @observable fileList = [];
  @observable success = false;
  @observable enableMd = false;
  @observable propertyLoading = false;
  @observable kbloading = false;
  @observable readme = '';
  @observable demoLoading = false;
  @observable mdLoading = false;
  @observable isEdit = false;
  @observable detailColSpan = 2;
  @observable kbList = [];
  @observable loadingForSubmit = false;
  @observable uploadFileList = [];  //云商店前台上传应用页面保存文件
  @observable uploadFileLoading = false;
  @observable uploadFileSubmit = true;
  @observable documentLoading = false;

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach((key) => {
      this[key] = params[key];
    })
  }
  @action
  setLoading = (mdLoading) => {
    this.mdLoading = mdLoading;
  }
  @action
  getFieldList = (params = {}) => {
    const param = {
      ...params,
      access_token: this.access_token,
    };
    return new Promise(resolve => {
      base.callApi('/v5/module/field/list', 'GET', param, 'json', 'text').then(action((data) => catchApiError(data, this.routing))).then(action((data) => {
        if (data.status) {
          this.fieldList = data.list;
          this.detailColSpan = data.colSpan || 2;
        } else {
          message.config({
            top: 60,
          })
          message.error(data.msg);
        }
        resolve(data);
      }));
    });
  }
  @action
  getPropertyList = (params = {}) => {
    const param = {
      ...params,
      access_token: this.access_token,
    };
    this.propertyLoading = true;
    return new Promise(resolve => {
      base.callApi('/v5/ecode/propertyList', 'GET', param, 'json', 'text').then(action((data) => catchApiError(data, this.routing))).then(action((data) => {
        this.propertyLoading = false;
        if (data.status) {
          const res = data.data.filter((da) => da.key !== '0'); // 过滤选项：‘全部’
          res.forEach((re) => {
            re.key = re.g_id;
            re.name = re.g_name || res.name;
          })
          this.propertyList = res;
          resolve(res);
        } else {
          message.config({
            top: 60,
          })
          message.error(data.msg);
        }
        resolve([]);
      }));
    }); 
  }
  @action
  getDemoInfo = (params = {}) => {
    const param = {
      ...params,
      access_token: this.access_token,
    };
    this.demoLoading = true;
    return new Promise(resolve => {
      base.callApi('/v5/ecode/demoInfo', 'GET', param, 'json', 'text').then(action((data) => catchApiError(data, this.routing))).then(action((data) => {
        if (data.status) {
          this.demoInfo = data.data;
          this.readme = data.data.readme || '';
        } else {
          message.config({
            top: 60,
          })
          message.error(data.msg);
        }
        this.demoLoading = false;
        resolve(data);
      }));
    }); 
  }
  @action
  fullDemoDetail = (params = {}, closeForm) => {
    const param = {
      ...params,
      id: this.id,
      access_token: this.access_token,
      readMe: this.readme,
    };
    this.loadingForSubmit = true;
    return new Promise(resolve => {
      base.callApi('/v5/ecode/fullDemoDetail', 'POST', param, 'json', 'text').then(action((data) => catchApiError(data, this.routing))).then(action((data) => {
        message.config({
          top: 60,
        })
        if (data.status) {
          if (closeForm) {
            this.success = true;
          } else {
            message.success("保存成功");
          }
          this.isEdit = false;
        } else {
          this.success = false;
          message.error(data.msg || "提交失败");
        }
        this.loadingForSubmit = false;
        resolve(data);
      }));
    }); 
  }
  @action
  getKb = (params = {}) => {
    const param = {
      ...params,
      access_token: this.access_token,
    };
    this.kbloading = true;
    return new Promise((resolve, reject) => {
      base.callApi('/v5/ecode/kbList', 'GET', param, 'json', 'text').then(action((data) => catchApiError(data, this.routing))).then(action((data) => {
        this.kbloading = false;
        if (data.status) {
          const result = data.data;
          const res = [];
          if (result) {
            result.forEach((v) => {
              res.push({
                key: v,
                name: v,
              })
            })
          }
          this.kbList = res;
          resolve(res);
        } else {
          message.config({
            top: 60,
          })
          message.error(data.msg);
          reject();
        }
      }));
    });
  }

  /**
   * 上传文件
   * @param {String} title 案例名
   */
  onUpload = (params = {}) => {
    this.uploadFileLoading = true;
    const datas = { ...params, access_token: getAccessToken() }
    const uploadFileList = toJS(this.uploadFileList);
    let formData = new FormData();
    uploadFileList.forEach(file => {
      // formData.append('files[]', file);
      formData.append('file', file.originFileObj);
    });
    Object.keys(datas).map(key => formData.append(key, datas[key]));
    return new Promise((resolve, reject) =>{
      fetch(window.server + '/v5/ecode/outLineDemo', {
        method: 'post',
        body: formData,
      }).then(response => {
        return response.json();
      }).then(data => {
        if(data.code === 113 && !data.status){
          message.error("未登录");
          this.routing.push('/login');
        } else if(data.status) {
          message.success(data.msg || "案例提交成功，请等待审核");
          resolve(data);
        } else {
          message.error(data.msg || '提交失败');
        }
        this.uploadFileLoading = false;
      }).catch(e => {
        console.error(e);
        this.uploadFileLoading = false;
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/stores/ecode/EcodeStore.js